<div class="dashboard-container">
  <div class="refresh-container">
    <div>
      {{electorDataService.user?.first_name}} {{electorDataService.user?.last_name}}
    </div>
    <button mat-icon-button [disabled] = "refreshLocked()" aria-label="Refresh Dashboard" i18n-aria-label 
      (click)="updateDashboard()" matTooltip="{{tooltipText}}" [matTooltipPosition]="'left'" 
      matTooltipHideDelay="100000">
        <mat-icon>refresh</mat-icon>
    </button>
  </div>
  <mat-accordion [multi]="false">
    <app-elections-panel></app-elections-panel>
    <app-petitions-panel></app-petitions-panel>
    <app-polls-panel></app-polls-panel>
    @if(idVerificationEnabled){
      <app-verification-panel #verificationPanel></app-verification-panel>
    }
    <app-organizations-panel></app-organizations-panel>
  </mat-accordion>
</div>
@if (displaySpinner || electorDataService.showSpinner()) {
  <div class="progressSpinner">
    <mat-spinner [diameter]="300" color="primary"></mat-spinner>
    <div class="spinner-warning">
      <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
    </div>
  </div>
}